// extracted by mini-css-extract-plugin
export var measureBox = "_bg-0";